export const RESPONSE_STATUS = {
  ok: 1,
  userNotLogged: -12,
  userPlusRedirect: -14
}
